import sections from '@/studio/settings/DomainSettings/sections';
import { showSuccessNotification, showErrorNotification, updateOrgInIndexedDb } from '@/utils/utils.js';
import {
  createPostmarkEmailSignature,
  getPostmarkEmailSignature,
  deletePostmarkEmailSignature,
  verifyPostmarkEmailSignature,
  createVanityEmailDomain,
  listVanityEmailDomain,
  destroyVanityEmailDomain,
  retrieveVanityEmailDomain,
  verifyVanityEmailDomain
} from '@goldcast/api/backend';

function checkError(errorObj) {
  let errorMessage = '';
  try {
    const parsedErrorObj = JSON.parse(errorObj.message);
    if (parsedErrorObj.code === 'EMAIL_SENDER_ALREADY_EXISTS')
      errorMessage = 'Email sender already exists. Please refresh to view the existing setup.';
    else if (parsedErrorObj.email_sender) {
      errorMessage = parsedErrorObj.email_sender[0].message;
    } else {
      errorMessage = parsedErrorObj.message;
    }
    const parsedErrorMessageObj = JSON.parse(parsedErrorObj.message);
    errorMessage = parsedErrorMessageObj.Message;
    return errorMessage;
  } catch {
    return errorMessage;
  }
}

export default {
  onClickNext({ commit, state }) {
    const { currentSectionId, currentModuleId } = state;

    // find next module index
    let nextModuleIndex;
    const currentSectionObj = sections.find(section => section.id === currentSectionId);
    const currentSectionModulesArr = currentSectionObj.modules;
    currentSectionModulesArr.find((module, index) => {
      if (module.id === currentModuleId) {
        nextModuleIndex = index + 1;
      }
    });

    if (nextModuleIndex < currentSectionModulesArr.length) {
      // go to next module in current section
      commit('setSection', {
        sectionId: currentSectionId,
        moduleId: currentSectionModulesArr[nextModuleIndex].id
      });
    } else {
      // if next module is not present then move to next section
      // find next section index
      let nextSectionIndex;
      sections.find((section, index) => {
        if (section.id === currentSectionId) {
          nextSectionIndex = index + 1;
        }
      });
      // if next section is not present then return from here otherwise go to next section
      if (!sections[nextSectionIndex]) return;
      commit('setSection', {
        sectionId: sections[nextSectionIndex].id,
        moduleId: sections[nextSectionIndex].modules[0].id
      });
    }
  },
  async createEmailSignature(context, { orgId, email, provider }) {
    context.commit('setCreateEmailSignatureLoading', true);
    try {
      const response = await createVanityEmailDomain({
        body: {
          email_sender: email,
          organization: orgId,
          provider: provider
        }
      });

      showSuccessNotification('Email Signature created successfully!');
      context.commit('setIsCurrentModuleInvalid', false);
      context.commit('setVanityEmailDomain', response);
      context.dispatch('onClickNext');
    } catch (error) {
      let errMessage = checkError(error);
      if (errMessage) {
        showErrorNotification(errMessage);
      } else {
        showErrorNotification(`Something went wrong, please try again`);
      }
    } finally {
      context.commit('setCreateEmailSignatureLoading', false);
    }
  },
  async getVanityEmailDomain(context, id) {
    context.commit('setRetrieveVanityEmailDomainsLoading', true);
    try {
      const response = await retrieveVanityEmailDomain({
        id
      });
      context.commit('setVanityEmailDomain', response);
      context.commit('setIsCurrentModuleInvalid', false);
    } catch (error) {
      showErrorNotification('Fetching vanity email domains failed!');
    } finally {
      context.commit('setRetrieveVanityEmailDomainsLoading', false);
    }
  },
  async getVanityEmailDomainsList(context, orgId) {
    context.commit('setFetchVanityEmailDomainsLoading', true);
    try {
      const response = await listVanityEmailDomain({
        queryParams: { organization: orgId }
      });
      context.commit('setVanityEmailDomains', response);
    } catch (error) {
      showErrorNotification('Fetching vanity email domains failed!');
    } finally {
      context.commit('setFetchVanityEmailDomainsLoading', false);
    }
  },
  async verifyEmailSignature(context) {
    context.commit('setVerifyEmailSignatureLoading', true);
    try {
      const response = await verifyVanityEmailDomain({ id: context.state.vanityEmailDomain.id });

      if (response.email_domain_verified) {
        showSuccessNotification('Email Signature verified successfully!');
        context.commit('setVanityEmailDomain', { ...context.state.vanityEmailDomain, email_domain_verified: true });
      } else {
        const secondsToWait = 20;

        context.commit('setIsVerificationPending', true);
        context.commit('setIsVerifyButtonClicked', true);
        await new Promise(resolve => setTimeout(resolve, secondsToWait * 1000));
        context.commit('setIsVerifyButtonClicked', false);
      }
    } catch (error) {
      showErrorNotification('Email Signature verification failed!');
    } finally {
      context.commit('setVerifyEmailSignatureLoading', false);
    }
  },
  async deleteEmailSignature(context, { orgId }) {
    context.commit('setDeleteEmailSignatureLoading', true);
    try {
      await destroyVanityEmailDomain({
        id: context.state.vanityEmailDomain.id
      });
      showSuccessNotification('Email Signature deleted successfully!');
    } catch (e) {
      showErrorNotification('Email Signature deletion failed!');
    } finally {
      context.commit('setDeleteEmailSignatureLoading', false);
    }
  }
};
